define('Cart.Lines.View.GiftWrap', [
    'SC.Configuration',
    'underscore'
], function CartLinesViewGiftWrap(
    Configuration,
    _
) {
    'use strict';

    var isGiftWrapLine = function isGiftWrapLine(context) {
        var giftWrap = _(context.line.options).findWhere({ cartOptionId: 'custcol_giftwrap_line_id' }) || {};

        return giftWrap.value && giftWrap.value.internalid;
    };

    return {
        mountToApp: function mountToApp(container) {
            var layoutComponent = container.getComponent('Layout');

            layoutComponent.addToViewContextDefinition('Cart.Lines.View', 'isGiftWrapLine', 'boolean', function isGiftWrapLn(context) {
                return isGiftWrapLine(context);
            });

            layoutComponent.addToViewContextDefinition('Cart.Lines.View', 'isNavigable', 'boolean', function isNavigable(context) {
                return !isGiftWrapLine(context) && context.isNavigable;
            });
        }
    };
});

